/* eslint no-return-assign: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEqual, cloneDeep } from 'lodash';
import constants from '@constants';
import { settingsMenuSections as SECTIONS } from '@config';

class SettingsMenu extends Component {
	constructor() {
		super();

		const stateObj = { };

		SECTIONS.forEach((section, index) => stateObj[section.id] = index === 0);

		this.state = cloneDeep(stateObj);
	}

	UNSAFE_componentWillReceiveProps = ({ sectionInView }) => {
		const lastProps = this.props;
		if (!isEqual(lastProps.sectionInView, sectionInView)) this.setActiveSection(sectionInView);
	}

	shouldComponentUpdate = ({ sectionInView }, nextState) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(lastProps.sectionInView, sectionInView)
			|| !isEqual(lastState, nextState)
		);
	}

	setActiveSection = (sectionId) => {
		const newState = cloneDeep(this.state);

		Object.keys(newState).forEach((key) => {
			if (key === sectionId) newState[key] = true;
			else newState[key] = false;
		});

		this.setState(newState);
	}

	getSections = () => {
		const { isStaffAdmin } = this.props;

		return SECTIONS.filter(({ staffOnly }) => (isStaffAdmin ? true : !staffOnly)).map((section, index) => {
			const { scrollTo } = this.props;
			const { state } = this;
			return (
				<div
					key={section.id}
					className={classNames('settings-menu-item', { active : state[section.id] })}
					onClick={() => scrollTo(section.id)}
					role="link"
					tabIndex={index * -1}
					onKeyPress={null}
				>
					<i className={`${section.icon} margin-right-5`} />
					{' '}
					{section.title}
				</div>
			);
		});
	};

	render() {
		const { personal } = this.state;

		return (
			<div className={classNames({ sticky : !personal })}>
				<h5 className="color-dark font-bold margin-bottom-10">Settings Menu</h5>
				{
					this.getSections()
				}
				<h5 className="color-dark font-bold margin-top-20">FAQ</h5>
				<p className="color-gray-regent"><small>How can I connect to my Bank Account?</small></p>
				<p className="color-gray-regent"><small>Why my Dashboard does not show any data?</small></p>
				<p className="color-gray-regent"><small>If I change my Avatar in one version will it appear in the next version?</small></p>
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={constants.STATIC_URLS.supportUrl}
					className="btn btn-link padding-left-0"
				>
					Visit FAQ Page
				</a>
			</div>
		);
	}
}

SettingsMenu.propTypes = {
	isStaffAdmin  : PropTypes.bool,
	scrollTo      : PropTypes.func.isRequired,
	sectionInView : PropTypes.string,
};

SettingsMenu.defaultProps = {
	isStaffAdmin  : false,
	sectionInView : '',
};

export default SettingsMenu;
